import request from '@/util/request';
import qs from 'qs';

// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 仪表名称选择树 /v4ward/iot/device/meterTree

export const meterTree = (params, options) =>
    request.get('/api/v4ward/iot/device/deptCostIotDeviceTree', Object.assign({}, options, { params }));

// 获取项目绑定部门及以下部门    /v4ward/dept/treeByProjectDeptId
export const treeByProjectDeptId = (params, options) =>
    request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

//     获取折线图数据 根据科室
export const getEnergyStatisticsElectDeptDayOneMonthInfo = (params, options) =>
    request.get('/api/v4ward/energy/statistics/elect/dept/day/getEnergyStatisticsElectDeptDayOneMonthInfo', Object.assign({}, options, { params }));

    //     获取折线图数据 根据仪表
export const getEnergyStatisticsElectMeterOneMonthInfo = (params, options) =>
request.get('/api/v4ward/energy/statistics/elect/meter/day/getEnergyStatisticsElectMeterOneMonthInfo', Object.assign({}, options, { params }));

//     获取当前登录人部门及子部门节点树/v4ward/dept/treeByIds
export const treeByIds = (params, options) =>
    request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));
